/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { Checkbox } from 'carbon-components-react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { useFormHelpers } from '../../hooks/useFormHelpers';

interface ControlledCheckboxProps {
  field: string;
  labelText: string;
  readOnly?: boolean;
  reversePolarity?: boolean;
  onChange?: (checked: boolean) => void;
}

const ControlledCheckbox = ({
  field,
  labelText,
  readOnly = false,
  reversePolarity = false
}: ControlledCheckboxProps) => {
  const formMethods = useFormContext();
  const { trigger } = formMethods;
  const { getFieldValue, updateFieldValue } = useFormHelpers(formMethods);
  return (
    <Checkbox
      id={field}
      labelText={labelText}
      disabled={readOnly}
      onChange={value => {
        updateFieldValue(field, reversePolarity ? !value : value);
        trigger();
      }}
      checked={getFieldValue(field) === !reversePolarity}
    />
  );
};

export { ControlledCheckbox };
